import { ReferenceData } from './reference-data.model';

export class Department extends ReferenceData {

  businessUnitAddressId: { correlation: string };

  // tslint:disable-next-line:no-any
  constructor(data: any) {
    super(data);
    this.businessUnitAddressId = data.businessUnitAddressId;
  }
}
